import { types } from 'mobx-state-tree';

const FormFieldId = {
  BILLING_CITY: 'BILLING_CITY',
  BILLING_COMPANY: 'BILLING_COMPANY',
  BILLING_COUNTRY: 'BILLING_COUNTRY',
  BILLING_EMAIL: 'BILLING_EMAIL',
  BILLING_FIRST_NAME: 'BILLING_FIRST_NAME',
  BILLING_IS_COMPANY: 'BILLING_IS_COMPANY',
  BILLING_LAST_NAME: 'BILLING_LAST_NAME',
  BILLING_NAME: 'BILLING_NAME',
  BILLING_PHONE: 'BILLING_PHONE',
  BILLING_POSTAL_CODE: 'BILLING_POSTAL_CODE',
  BILLING_STREET_ADDRESS: 'BILLING_STREET_ADDRESS',
  BILLING_VAT_NUMBER: 'BILLING_VAT_NUMBER',
  CAMPAIGN_CODE: 'CAMPAIGN_CODE',
  DELIVERY_ADDRESS_DROPDOWN: 'DELIVERY_ADDRESS_DROPDOWN',
  DELIVERY_FIRST_NAME: 'DELIVERY_FIRST_NAME',
  DELIVERY_LAST_NAME: 'DELIVERY_LAST_NAME',
  DELIVERY_CITY: 'DELIVERY_CITY',
  DELIVERY_COMPANY: 'DELIVERY_COMPANY',
  DELIVERY_COUNTRY: 'DELIVERY_COUNTRY',
  DELIVERY_IS_COMPANY: 'DELIVERY_IS_COMPANY',
  DELIVERY_NAME: 'DELIVERY_NAME',
  DELIVERY_PHONE: 'DELIVERY_PHONE',
  DELIVERY_POSTAL_CODE: 'DELIVERY_POSTAL_CODE',
  DELIVERY_STREET_ADDRESS: 'DELIVERY_STREET_ADDRESS',
  DELIVERY_VAT_NUMBER: 'DELIVERY_VAT_NUMBER',
  EXTRA_MESSAGE: 'EXTRA_MESSAGE',
  FIRSTNAME: 'FIRSTNAME',
  IS_COMPANY: 'IS_COMPANY',
  LASTNAME: 'LASTNAME',
  NEWSLETTER_SUBSCRIPTION: 'NEWSLETTER_SUBSCRIPTION',
  PRIVACY_STATEMENT: 'PRIVACY_STATEMENT',
  PRODUCT_REFERENCE: 'PRODUCT_REFERENCE',
  SEPARATE_DELIVERY_ADDRESS: 'SEPARATE_DELIVERY_ADDRESS',
  REGISTER_VISITOR_CUSTOMER: 'REGISTER_VISITOR_CUSTOMER'
};

export default FormFieldId;

export const FormFieldIdType = types.enumeration(
  'FormFieldIdType',
  Object.values(FormFieldId)
);
